/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize RiskRegister List View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './RiskRegisterListView';

export const mapStateToPropsRiskRegisterList = mapStateToProps;
export const mapDispatchToPropsRiskRegisterList = mapDispatchToProps;

export default connect(
  mapStateToPropsRiskRegisterList,
  mapDispatchToPropsRiskRegisterList
)(View);
